var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elementType,_vm._b({tag:"div"},'div',_vm.loadAttributes,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }